// utils/quillBlots/inlineComment.js
import Quill from "quill";

const Inline = Quill.import("blots/inline");

class InlineCommentBlot extends Inline {
  static blotName = "inlineComment";
  static tagName = "span";
  static className = "ql-inline-comment";

  static create(value) {
    const node = super.create();

    if (value?.id) {
      node.setAttribute("data-comment-id", value.id);
    }

    if (value?.active) {
      node.classList.add("ql-inline-comment--active");
    }
    return node;
  }

  static formats(node) {
    const id = node.getAttribute("data-comment-id");
    const active = node.classList.contains("ql-inline-comment--active");

    if (!id && !active) {
      return null; // tells Quill: “no inlineComment format here”
    }

    return { id, active };
  }

  format(name, value) {
    if (name === "inlineComment") {
      if (!value) {
        this.domNode.removeAttribute("data-comment-id");
        this.domNode.classList.remove(
          "ql-inline-comment",
          "ql-inline-comment--active"
        );
      } else {
        this.domNode.setAttribute("data-comment-id", value.id);

        if (value.active) {
          this.domNode.classList.add("ql-inline-comment--active");
        } else {
          this.domNode.classList.remove("ql-inline-comment--active");
        }
      }
    } else {
      super.format(name, value);
    }
  }
}

Quill.register(InlineCommentBlot);
